import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from './styled/Text';
import { colors } from '../constants';

const STATES = {
  DEFAULT: 'default',
  ERROR: 'error',
};

const getInputHeight = size => {
  switch (size) {
    case 'large':
      return '48px';
    case 'medium':
      return '40px';
    default:
      return '48px';
  }
};

const Title = styled(Text)`
  margin-bottom: 8px;
`;

const ErrorMessage = styled(Text)`
  margin-top: 8px;s
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  padding: 12px 16px;
  height: ${props => getInputHeight(props.size)};
  width: 238px;
  border-radius: 6px;
  border: 1px solid;
  border-color: ${colors.grey80};
  font-family: 'Rubik', sans-serif;
  color: ${colors.navy};
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  :hover,
  :focus {
    border-color: ${colors.green};
  }
  ::placeholder {
    font-family: 'Rubik', sans-serif;
    color: ${colors.grey80};
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
  }
`;

const TextInput = ({
  type,
  state,
  value,
  onChange,
  onBlur,
  placeholder,
  title,
  size,
  errorMessage,
  disabled,
}) => {
  return (
    <Container>
      {title && <Title variant="body-bold">{title}</Title>}
      <Input
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        state={state}
        type={type}
        size={size}
        disabled={disabled}
      />
      {errorMessage && state === STATES.ERROR && (
        <ErrorMessage variant="caption" color={colors.red}>
          {errorMessage}
        </ErrorMessage>
      )}
    </Container>
  );
};

TextInput.propTypes = {
  type: PropTypes.string,
  state: PropTypes.oneOf(Object.values(STATES)),
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOf(['large', 'medium']),
  errorMessage: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
};

TextInput.defaultProps = {
  type: 'text',
  state: STATES.DEFAULT,
  placeholder: '',
  title: '',
  errorMessage: '',
  size: 'large',
};

export default TextInput;
